// @ts-ignore
/* eslint-disable */
import request from '@/request';

/** getScoringResultCountByAppId GET /api/userAnswer/resultCount */
export async function getScoringResultCountByAppIdUsingGet(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getScoringResultCountByAppIdUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResponseListAppResultCountDTO_>('/api/userAnswer/resultCount', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** getTopApp GET /api/userAnswer/topApp */
export async function getTopAppUsingGet(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getTopAppUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResponseListAppAnswerCountDTO_>('/api/userAnswer/topApp', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
